import React from 'react'
import PropTypes from 'prop-types'
import Tether from '../../Tether'
import styles from '../Table.css'

const Settings = ({ settingsComponents, style, className, ...props }) => {
  let renderer
  if (settingsComponents) {
    renderer = settingsComponents.map((SettingsComponent, i) => {
      if (!SettingsComponent) {
        return null
      }
      return (
        <div key={SettingsComponent.key || i}>
          <SettingsComponent />
        </div>
      )
    })
  }

  return (
    <div style={style} className={className}>
      <Tether
        isOpen={true}
        className={styles.fullHeight}
        contentClassName={styles.high}
        triggerClassName={styles.fullHeight}
        placement='top-end'
        triggerOn={['click']}
        content={<div className={styles.settingContents}>{renderer}</div>}>
        <div className={styles.settingTrigger} />
      </Tether>
    </div>
  )
}

export default Settings



// WEBPACK FOOTER //
// ../src/components/Table/components/Settings.js